module.exports = __webpack_public_path__ + "static/media/song.8093f445.jpg";